/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { configureStore, Store } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import loginReducer from "state/login";
import appReducer from "state/app";

export const store = configureStore({
	reducer: {
		login: loginReducer,
		app: appReducer,
		// [classApi.reducerPath]: classApi.reducer,
	},
});

// setupListeners(store.dispatch);

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>
);
